<template>
  <div>
    <b-button
        size="md"
        style="background-color:#0fb6fe"
        class="mb-2"
        @click="handleFeedbackThumbsUp(true)"
    >
      <b-icon
          :icon="`hand-thumbs-up${feedbackLatest && feedbackLatest.isLiked ? '-fill':''}`"
          aria-label="Thumbs Up"
      />
    </b-button>
    <b-button
        style="margin-left: 15px; background-color:#0fb6fe"
        size="md"
        class="mb-2"
        @click="handleFeedbackThumbsUp(false)"
    >
      <b-icon
          :icon="`hand-thumbs-down${feedbackLatest && !feedbackLatest.isLiked ? '-fill':''}`"
          aria-label="Thumbs Up"
      />
    </b-button>
    <b-link
        v-if="false"
        style="margin-left: 15px"
    >
      Provide Feedback
    </b-link>
  </div>
</template>

<script>
export default {
  name: "Display_PaneResponse_Feedback",
  components: {},
  created(){},
  mounted() {},
  props: {
    path: {
      type: String,
      required: false,
      default: ''
    },
    currDoc: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
    profile: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
  },
  computed: {
    feedbacksOrdered() {
      let _feedbacks = this.currDoc && this.currDoc.feedbacks ? this.currDoc.feedbacks : [];
      return _feedbacks && Array.isArray(_feedbacks) ?
          _feedbacks.sort((a, b)=> {
            if (a._created_at && b._created_at && a._created_at.seconds && b._created_at.seconds) {
              this.momentTest = a._created_at.seconds
              return   b._created_at.seconds - a._created_at.seconds;
            } return false;
          }) : [];
    },
    feedbackLatest(){
      return this.feedbacksOrdered && Array.isArray(this.feedbacksOrdered) && this.feedbacksOrdered.length > 0 ?
          this.feedbacksOrdered[0] : null
    }
  },
  methods: {
    handleFeedbackThumbsUp(isLiked) {
      const updatedBy = this.profileBy();

      const feedback = {
        isLiked: isLiked,
        _created_by: updatedBy,
        _created_at: new Date()
      };

      if (this.comment) feedback.comment = this.comment;

      this.$store
          .dispatch("ai/addFeedbackForPathAndDocId", {
            path: this.path,
            docId: this.currDoc ? this.currDoc.id : null,
            feedback: feedback
          })
          .then(({length}) => {
          })
          .catch(err => {
          });
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
        imgURL: this.profile ? this.profile.imgURL : null
      };
    },
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
